/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faX } from "@fortawesome/pro-solid-svg-icons";

import { Timepicker as BaseTimepicker } from "@/ui-lib/FormFields";

import styles from "./Timepicker.module.scss";

const Timepicker = ({
  id,
  containerClassName,
  errors,
  withoutError,
  invalid,
  setFieldValue,
  setFieldTouched,
  onChange,
  onClear,
  ...props
}) => {
  const handleChange = (e) => {
    const { value } = e;

    setFieldValue(id, value || "");
    setFieldTouched(id, true);

    onChange(id, value);
  };

  const handleClear = () => {
    if (onClear) {
      onClear();
    }

    setFieldValue(id, "");
  };

  const error = !!(errors[id] || invalid) && !withoutError;

  return (
    <div
      className={cx(
        styles.inputContainer,
        error && errors[id] && props.touched[id] ? styles.inputError : "",
        containerClassName
      )}
    >
      <BaseTimepicker {...props} onChange={handleChange} />
      {error && errors[id] && props.touched[id] && (
        <div className={styles.errorMessage}>{errors[id]}</div>
      )}
      {props.value && (
        <div className={styles.icon} onClick={() => handleClear()}>
          <FontAwesomeIcon icon={faX} />
        </div>
      )}
    </div>
  );
};

Timepicker.defaultProps = {
  setFieldTouched: () => null,
  setFieldValue: () => null,
  onChange: () => null,
  onClear: () => null,
  withoutError: false,
  invalid: false,
  errors: {},
  containerClassName: "",
  className: "",
};

Timepicker.propTypes = {
  setFieldTouched: PropTypes.func,
  setFieldValue: PropTypes.func,
  onChange: PropTypes.func,
  onClear: PropTypes.func,
  id: PropTypes.string.isRequired,
  withoutError: PropTypes.bool,
  invalid: PropTypes.bool,
  errors: PropTypes.shape({}),
  containerClassName: PropTypes.string,
  className: PropTypes.string,
};

export default Timepicker;
